// uploadAndSubmissionUtil.js
import { uploadToS3V2, createAcoeSubmissionParams } from '../db/aws_s3_utils.js';
import { triggerBackgroundSync } from './service_worker_utils.js';
import { addUploadItem } from "../db/index_db_utils.js";
import config from "./conf.js";

/**
 * Orchestrator: uploads JSON to S3
 * 
 * @param {Object} options - Contains dependencies and configuration.
 * @param {Object} options.userData       - Contains user-related data (UUID, origin, etc.)
*/
export async function jsonUploadTrigger(options){
    const { userData } = options;
    const bodyData = localStorage.getItem("results");
    const jsonBlob = new Blob([bodyData], { type: "application/json" });
    const params = {
      baseUrl: config.COGNET_DB_API_URL,
      patientId: userData.UUID,
      dbName: userData.origin,
      testType: userData.examType,
      attempt: userData.attemptNumber,
      screenId: "results",
      extension: "JSON",
      contentType: "application/json",
      fileBuffer: jsonBlob
    };
    try {
      await uploadToS3V2(params);
    } catch (err) {
      console.warn('PUT failed, queueing for background‑sync:', err);
      await addUploadItem({ params });
      await triggerBackgroundSync();
    }
}

/**
 * Orchestrator: Submits autonocog data to the DB API.
 *
 * @param {Object} params - Submission parameters
 */
export async function handleAutonocogSubmission(params) {
  try {
    console.log('submitting autonocog to: ', params);
    const r = await fetch(params.url, {
      method: params.method,
      body: params.body
    });
    if (!r.ok) console.log('Error detail: ', await r.json());
  } catch (error) {
    console.error("Error suppressed:", error);
  }
}

/**
 * Orchestrator: uploads JSON to S3 and submits autonocog data to the DB API.
 *
 * @param {Object} options - Contains dependencies and configuration.
 * @param {Object} options.userData       - Contains user-related data (UUID, origin, etc.)
 */
export async function uploadJsonAndSubmitAutonocog(options) {
  const { userData } = options;
  await jsonUploadTrigger({ userData });
  const submissionParams = createAcoeSubmissionParams(userData);
  await handleAutonocogSubmission(submissionParams);
}
